import React from 'react'
import supportedSocialChannels from '../../../../utilities/social/supportedSocialChannels'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

import _ from 'lodash'
import '../../../../styles/css/components/social/bk-flow-social-share.css'

const BkFlowSocialShare = (props) => {
  const {
    hotelLabels,
    socialMenuEvent,
    socialMenuVisible,
  } = props

  let renderSocialOptions = []

  if (!_.isEmpty(supportedSocialChannels)) {
    for (const socialKey in supportedSocialChannels) {
      const currentSocial = supportedSocialChannels[socialKey]

      renderSocialOptions.push(
        <button
          key={currentSocial.type}
          className="bk-flow__social-share-toggle btn btn-primary"
          onClick={
            () => window.open(
              currentSocial.apiLink,
              'sharer',
              'toolbar=0, status=0, width=600, height=400'
            )
          }
        >
          <img
            src={currentSocial.icon}
            alt={currentSocial.type + ' Share'}
          />
        </button>
      )
    }
  }

  return (
    renderSocialOptions ? (
      <div className="bk-flow__social-share">
        <button
          className="confirmation-action btn btn-primary"
          onClick={() => socialMenuEvent(!socialMenuVisible)}
        >
          <i className="material-icons">share</i>
          {hotelLabels.share ? hotelLabels.share : 'Share'}
        </button>

        { socialMenuVisible &&
          <ClickAwayListener onClickAway={ () => socialMenuEvent(false) }>
            <div className="bk-flow__social-share-menu">
              {renderSocialOptions}
            </div>
          </ClickAwayListener>
        }
      </div>
    ) : (
      null
    )
  )
}

export default BkFlowSocialShare



// WEBPACK FOOTER //
// ./src/components/confirmation/elements/condensed/BkFlowSocialShare.js